export const actions = {
    MADLEN_INTEGRATION_GET_LIST: 'MADLEN_INTEGRATION_GET_LIST',
    MADLEN_INTEGRATION_SET_LIST: 'MADLEN_INTEGRATION_SET_LIST',
    MADLEN_INTEGRATION_CREATE_SEND_CONTENT_JOB: 'MADLEN_INTEGRATION_CREATE_SEND_CONTENT_JOB',
    MADLEN_SEND_CONTENT: 'MADLEN_SEND_CONTENT',
    MADLEN_INTEGRATION_GET_CONTENTS: 'MADLEN_INTEGRATION_GET_CONTENTS',
    MADLEN_INTEGRATION_SET_CONTENTS: 'MADLEN_INTEGRATION_SET_CONTENTS',
    MADLEN_INTEGRATION_GET_MADLEN_URL: 'MADLEN_INTEGRATION_GET_MADLEN_URL',
    MADLEN_INTEGRATION_SET_MADLEN_URL: 'MADLEN_INTEGRATION_SET_MADLEN_URL',
 };